import {makeAutoObservable} from 'mobx';
import {County} from '../../entity/model/county';
import CountyAgent from '../agent/county-agent';

export default class CountyStore {
  counties: County[] = [];
  cache: boolean = false;
  countyAgent: CountyAgent;

  constructor(countyAgent: CountyAgent) {
    makeAutoObservable(this);
    this.countyAgent = countyAgent;
  }

  getCounties = async (): Promise<County[]> => {
    try {
      this.counties = await this.countyAgent.getCounties();
      this.cache = true;
    } catch (error: any) {
      console.error('Error occurred while loading the counties', error);
    }

    return this.counties;
  }

  getCountyByStateId = async (stateId: string): Promise<County[]> => {
    return await this.countyAgent.getCountyByStateId(stateId);
  }

}
